import { StatusActionsBar } from '@/components/StatusActionsBar';
import { RoundedButton } from '@/components/buttons';
import { RegistersPaths } from '@/router';
import { useRegistryFile } from '../../shared';
import { useNavigate, useParams } from 'react-router-dom';
import { RegistryAlias } from '@/api/domains/registers.types';

const CloseButton = () => {
  const navigate = useNavigate();
  const { alias } = useParams<{ alias: RegistryAlias }>();
  const registryListFile = useRegistryFile();

  const handleClick = () => {
    if (!alias) return;

    const path = registryListFile ? RegistersPaths.generateRegistryBindingPath({ alias }) : RegistersPaths.ROOT_PATH;

    navigate(path);
  };

  return <RoundedButton onClick={handleClick}>Закрыть</RoundedButton>;
};

export const RegistryImportLogActionBar = () => <StatusActionsBar actions={<CloseButton />} />;
